module.exports = __webpack_public_path__ + "media/assets/images/flags/pm-b9c358e5a6f0e5ae2fe236ca62064911.svg";